"use strict";exports.__esModule = true;exports.symbol = symbol;function symbol() {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 4 18" id=icon-overflow><path d="M2 4A2 2 0 102.001.001 2 2 0 002 4zm0 7a2 2 0 10.001-3.999A2 2 0 002 11zm2 5a2 2 0 11-3.999.001A2 2 0 014 16z"></path></symbol>';
}